import { Col, Colors, IcEdit, IcMenuChange, IcTrash } from 'basic-ui-lib';
import StoreItemMobile from '../StoreItemMobile';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';
import MenuActionMobile from 'basic-ui-lib/components/MenuActionMobile';
import navigate from 'utils/navigate';
import { IStore } from 'modules/store/interfaces/api';
import { useState } from 'react';
import { ItemMenuProps } from 'basic-ui-lib/components/MenuActionMobile/ItemMenu';

interface IStoreTableMobileProps {
  handleDeleteStore: (storeId: string) => void;
  handleResetPassword: (storeId: string) => void;
}

const StoreTableMobile = ({ handleDeleteStore, handleResetPassword }: IStoreTableMobileProps) => {
  const { storesList } = useGetListStores();
  const [selectedStore, setSelectedStore] = useState<IStore | null>(null);
  const [open, setOpen] = useState(false);

  const listMenu = [
    {
      key: 'edit-store',
      title: 'Edit Store',
      icon: <IcEdit width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'delete-store',
      title: 'Delete Store',
      icon: <IcTrash width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'reset-password',
      title: 'Reset Password',
      icon: <IcMenuChange width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
  ];

  const handleSelectStore = (item: IStore) => {
    setSelectedStore(item);
    setOpen(true);
  };

  const handleMenuClick = (item: ItemMenuProps) => {
    if (!selectedStore) return;
    switch (item.key) {
      case 'edit-store':
        navigate(`/store/edit/${selectedStore.storeId}`);
        break;
      case 'delete-store':
        handleDeleteStore(selectedStore.storeId);
        break;
      case 'reset-password':
        handleResetPassword(selectedStore.storeId);
        break;
    }
  };

  return (
    <Col flex={1}>
      {storesList?.content?.map((store) => (
        <StoreItemMobile
          key={store.storeId}
          item={store}
          onClick={() => navigate(`/store/${store.storeId}`)}
          onClickMenu={() => handleSelectStore(store)}
        />
      ))}
      <MenuActionMobile listMenu={listMenu} open={open} onClose={() => setOpen(false)} onClickMenu={handleMenuClick} />
    </Col>
  );
};

export default StoreTableMobile;
